"use client";
import {
  heading
} from "./chunk-BJ3SDZMT.mjs";

// src/components/atoms/Heading/Heading.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Heading = forwardRef(function Heading2({
  text = "Eu sou um heading",
  highlights,
  type = "h1",
  highlightColor = "#000000"
}, ref) {
  const HeadingTag = type;
  const renderTextWithHighlights = (text2) => {
    let modifiedText = text2;
    highlights && highlights.forEach((word) => {
      const regex = new RegExp(`(${word})`, "gi");
      modifiedText = modifiedText.replace(
        regex,
        (match) => `<span style="color: ${highlightColor}">${match}</span>`
      );
    });
    return modifiedText;
  };
  return /* @__PURE__ */ jsx(
    HeadingTag,
    {
      ref,
      className: heading({ type }),
      dangerouslySetInnerHTML: { __html: renderTextWithHighlights(text) }
    }
  );
});
var Heading_default = Heading;

export {
  Heading_default
};
